// extracted by mini-css-extract-plugin
export default {"root":"IconFavourites_root__b0Tmn"};